import { gql } from '@/__generated__/gql';

export const LIST_ALLOCATION_OPERATIONS_WORKFLOW_TRANSITION_HISTORY_QUERY = gql(`
  query TransactionDetailsPageListAllocationOperationsWorkflowTransitionHistory($data: ListAllocationOperationsWorkflowTransitionHistoryInput!) {
    listAllocationOperationsWorkflowTransitionHistory(data: $data) {
      page
      pageSize
      total
      data {
        id
        allocationId
        operationsWorkflowTransitionTaskId
        userId
        tenantId
        createdAt
        allocation {
          id
          allocationStatus
          suitability
          terminationReason
          terminationNote
        }
        operationsWorkflowTransitionTask {
          id
          name
        }
        user {
          id
          firstName
          lastName
        }
        platformManagerTenantName
      }
    }
  }
`);

export const ENVELOPE_RECIPIENTS_QUERY = gql(`
  query TransactionDetailsPageEnvelopeRecipients($data: EnvelopeRecipientsArgs!) {
    envelopeRecipients(data: $data) {
      total
      perPage
      page
      data {
        routingOrder
        role
        email
        name
        completedAt
      }
    }
  }
`);

export const GET_ENVELOPE_RECIPIENTS_TOTAL_QUERY = gql(`
  query TransactionDetailsPageEnvelopeRecipientsTotal($data: EnvelopeRecipientsArgs!) {
    envelopeRecipients(data: $data) {
      total
    }
  }
`);

export const LIST_WET_SIGNATURE_UPLOAD_HISTORY_QUERY = gql(`
  query TransactionDetailsPageListWetSignatureUploadHistory($data: WetSignatureUploadHistoryInputDto!) {
    listWetSignatureUploadHistory(data: $data) {
      fileName
      versionDate
      task
      completedBy
      email
    }
  }
`);
